import { mergeStyles } from '@uifabric/merge-styles'
import React from 'react'
import { PresetButton } from './preset_button'

export const PresetSection = ({callback}: {callback: Function}) => (
	<div className={mergeStyles({
		display: 'flex',
		justifyContent: 'center',
		marginBottom: 12,
	})}>
		<PresetButton name="Code" callback={callback} />
		<PresetButton name="Lorem" callback={callback} />
		<PresetButton name="Verse" callback={callback} />
		<PresetButton name="Shakespeare" callback={callback} />
		<PresetButton name="Quote" callback={callback} />
	</div>
)